import { render, staticRenderFns } from "./TitleTextMoreStyle.vue?vue&type=template&id=0b8b39c0&scoped=true"
import script from "./TitleTextMoreStyle.vue?vue&type=script&lang=js"
export * from "./TitleTextMoreStyle.vue?vue&type=script&lang=js"
import style0 from "./TitleTextMoreStyle.vue?vue&type=style&index=0&id=0b8b39c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b39c0",
  null
  
)

export default component.exports